var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81323 7.04006C9.81323 6.95339 9.86657 6.86673 9.9599 6.80673C10.0532 6.74673 10.1799 6.70673 10.3132 6.70673H11.3132C11.4466 6.70673 11.5732 6.74006 11.6666 6.80673C11.7599 6.86673 11.8132 6.95339 11.8132 7.04006V7.70673C11.8132 7.79339 11.7599 7.88006 11.6666 7.94006C11.5732 8.00006 11.4466 8.04006 11.3132 8.04006H10.3132C10.1799 8.04006 10.0532 8.00673 9.9599 7.94006C9.86657 7.88006 9.81323 7.79339 9.81323 7.70673V7.04006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 3.14667H3.77325C2.97796 3.14667 2.33325 3.79138 2.33325 4.58667V12.1867C2.33325 12.982 2.97796 13.6267 3.77325 13.6267H12.2266C13.0219 13.6267 13.6666 12.982 13.6666 12.1867V4.58667C13.6666 3.79138 13.0219 3.14667 12.2266 3.14667Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53999 5.53998H13.56V4.13332C13.56 4.13332 13.42 3.24665 12.6 3.21332H3.74666C3.74666 3.21332 2.02666 3.29332 2.53999 5.53998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63989 3.36002V2.37335",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3599 3.36002V2.37335",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveIcon);
export default __webpack_public_path__ + "static/media/leave-icon.ad30fd4b195fb7f30467fd248282ac1f.svg";
export { ForwardRef as ReactComponent };